__turbopack_context__.v({
  "collapsed": "ExpandableCards-module-scss-module__5AHUcW__collapsed",
  "content": "ExpandableCards-module-scss-module__5AHUcW__content",
  "expanded": "ExpandableCards-module-scss-module__5AHUcW__expanded",
  "feature": "ExpandableCards-module-scss-module__5AHUcW__feature",
  "featureImage": "ExpandableCards-module-scss-module__5AHUcW__featureImage",
  "featureText": "ExpandableCards-module-scss-module__5AHUcW__featureText",
  "featureTitle": "ExpandableCards-module-scss-module__5AHUcW__featureTitle",
  "features": "ExpandableCards-module-scss-module__5AHUcW__features",
  "icon": "ExpandableCards-module-scss-module__5AHUcW__icon",
  "iconActive": "ExpandableCards-module-scss-module__5AHUcW__iconActive",
  "imageContainer": "ExpandableCards-module-scss-module__5AHUcW__imageContainer",
});
